"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var lodash_isempty_1 = __importDefault(require("lodash.isempty"));
var _well_1 = __importDefault(require("../../atoms/_well"));
var tokens_1 = require("../../tokens");
var FormGroup = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var wrappedChildren = React.Children.map(children, function (child) {
        if (lodash_isempty_1.default(child)) {
            return null;
        }
        else {
            return React.createElement(FormGroup.FormWrapper, null, child);
        }
    });
    return (React.createElement(FormGroup.Element, __assign({}, automation_attribute_1.default('form-group'), props), wrappedChildren));
};
FormGroup.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
FormGroup.FormWrapper = styled_1.default(_well_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  margin-bottom: ", ";\n  padding-bottom: ", ";\n"], ["\n  ", ";\n  margin-bottom: ", ";\n  padding-bottom: ", ";\n"])), container_styles_1.default, tokens_1.spacing.medium, tokens_1.spacing.xlarge);
FormGroup.defaultProps = {};
exports.default = FormGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=form-group.js.map